import { render } from "./EmailTemplate.vue?vue&type=template&id=5bfb77b0&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"

import "./EmailTemplate.vue?vue&type=style&index=0&id=5bfb77b0&lang=css"
import "./EmailTemplate.vue?vue&type=style&index=1&id=5bfb77b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfb77b0"]])

export default __exports__